/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";


const Deployments = function (deploymentId) {

    /**
     * Returns information about the deployment
     * @returns {Promise<{indexKey, status: string, phase: string, objectType: string, userInput: object, defaultsSet: object, timestamp: number, startedTimestamp: number, doneTimestamp: number, duration: number}>}
     */
    async function getInfo() {
        return callWSFunction("deployments.getInfo", {
            deploymentId: deploymentId
        })
    }

    /**
     * Returns all currently running deployments
     * @returns {Promise<{success: boolean, deployments: object[]}>}
     */
    async function listRunning() {
        return callWSFunction("deployments.listRunning", {})
    }

    return {
        getInfo,
        listRunning,
    }
}

export {Deployments}